import { useState } from "react";
import type { FormEvent } from "react";
import { TurnstileWidget } from "../components/TurnstileWidget";
import { signup } from "../lib/api";
import { formatCooldownMessage, getEmailCooldownRemainingMs, startEmailCooldown, useEmailCooldown } from "../lib/email-cooldowns";

export function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [turnstileToken, setTurnstileToken] = useState<string | undefined>();
  const [message, setMessage] = useState<string | null>(null);
  const verificationCooldownMs = useEmailCooldown("verification", email);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const remainingCooldownMs = getEmailCooldownRemainingMs("verification", email);
    if (remainingCooldownMs > 0) {
      setMessage(formatCooldownMessage(remainingCooldownMs));
      return;
    }

    try {
      await signup(email, password, turnstileToken);
      startEmailCooldown("verification", email);
      setMessage(
        "Check your Dartmouth inbox for the verification link. If you do not see it there, please check your junk or spam folder.",
      );
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Could not create account.");
    }
  }

  return (
    <section className="form-panel auth-panel">
      <div className="section-heading">
        <p className="eyebrow">Sign up</p>
        <h1 className="compact-title">Join Layup List</h1>
      </div>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label>
          Dartmouth email
          <input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
        </label>
        <label>
          Password
          <input required minLength={8} maxLength={128} type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </label>
        <TurnstileWidget onToken={setTurnstileToken} />
        <button type="submit" className="primary-link" disabled={verificationCooldownMs > 0}>
          {verificationCooldownMs > 0 ? `Wait ${Math.ceil(verificationCooldownMs / 1000)}s` : "Create account"}
        </button>
      </form>
      {message ? <p className="status-message" role="status" aria-live="polite">{message}</p> : null}
    </section>
  );
}
